"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _styles = require("./styles");

var _CheckBox = require("../CheckBox");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _jsxRuntime = require("react/jsx-runtime");

var Card = function Card(_ref) {
  var _ref$card = _ref.card,
      card = _ref$card === void 0 ? {} : _ref$card,
      selectedCard = _ref.selectedCard,
      setSelectedCard = _ref.setSelectedCard,
      setCard = _ref.setCard,
      setStripe = _ref.setStripe;
  var stripe = (0, _reactStripeJs.useStripe)();

  var handleOnChange = function handleOnChange(e, cardId) {
    if (e.target.checked) {
      setCard && setCard((0, _objectSpread2.default)((0, _objectSpread2.default)({}, card), {}, {
        isNew: 0
      }));
      setStripe && setStripe(stripe);
      setSelectedCard && setSelectedCard(cardId);
    } else {
      setSelectedCard && setSelectedCard("");
      setCard && setCard(null);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "card-details",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.CheckBox, {
        id: card.id,
        label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "brand-card",
            children: card.brand
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: "**** **** **** ".concat(card.last4)
          })]
        }),
        checked: selectedCard === card.id,
        onChange: function onChange(e) {
          return handleOnChange(e, card.id);
        }
      })
    })
  });
};

exports.Card = Card;